import React from 'react';
import { formatCurrency, formatPercent, STATUS_LABELS } from './formatters';
import './MethodsBreakdown.css';

/**
 * MethodsBreakdown — renders all 11 valuation methods with traces.
 *
 * Props:
 *   methods {Array} — result.methods from computeMVA output (engine order)
 *   perMethodRationale {Object} — method id -> weighting reason (from result.weightProfile)
 */
function MethodsBreakdown({ methods = [], perMethodRationale = {} }) {
  return (
    <section className="methods-breakdown-section">
      <h3 className="methods-breakdown-heading">The 11 valuation methods</h3>
      <ul className="methods-breakdown-list">
        {methods.map((method) => {
          const isOk = method.status === 'ok';
          const isActive = method.weight > 0;

          return (
            <li key={method.id} className="methods-breakdown-row">
              <div className="methods-breakdown-header">
                <span className="methods-breakdown-label">{method.label}</span>

                <span className="methods-breakdown-value">
                  {isOk ? formatCurrency(method.value) : '—'}
                </span>

                <span
                  className={`methods-breakdown-weight-chip${isActive ? ' methods-breakdown-weight-chip--active' : ''}`}
                  title={isActive ? 'drives your headline number' : undefined}
                >
                  {formatPercent(method.weight)}
                </span>

                <span
                  className={`methods-breakdown-status-badge status-${method.status}`}
                >
                  {STATUS_LABELS[method.status] || method.status}
                </span>

                {method.riskApplied && (
                  <span
                    className="methods-breakdown-risk-tag"
                    title="This method's multiple is adjusted by your risk profile"
                  >
                    Risk-adjusted
                  </span>
                )}
              </div>

              {method.trace && method.trace.length > 0 && (
                <details className="methods-breakdown-details">
                  <summary className="methods-breakdown-summary">
                    How this was calculated
                  </summary>
                  {perMethodRationale[method.id] && (
                    <p className="methods-breakdown-weight-reason">
                      {perMethodRationale[method.id]}
                    </p>
                  )}
                  <ul className="methods-breakdown-trace">
                    {method.trace.map((line, idx) => (
                      <li key={idx} className="methods-breakdown-trace-line">
                        {line}
                      </li>
                    ))}
                  </ul>
                </details>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default MethodsBreakdown;
